import React from "react";
import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Home, Newspaper, HelpCircle, Mail, ScrollText, LogOut, MessageSquare, Handshake, Calendar, AlertTriangle, Wrench, Navigation, Activity, Camera } from "lucide-react";

const DETMOLD_LOGO = "/assets/logo-detmold.png";

const links = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/startseite", label: "Startseite", icon: Home },
  { to: "/admin/news", label: "News", icon: Newspaper },
  { to: "/admin/bauchroniken", label: "Bauchroniken", icon: Camera },
  { to: "/admin/termine", label: "Termine", icon: Calendar },
  { to: "/admin/sperrungen", label: "Sperrungen", icon: AlertTriangle },
  { to: "/admin/faqs", label: "FAQs", icon: HelpCircle },
  { to: "/admin/partners", label: "Partner", icon: Handshake },
  { to: "/admin/newsletter", label: "Newsletter", icon: Mail },
  { to: "/admin/berufsverkehr-ticker", label: "Berufsverkehr-Ticker", icon: Navigation },
  { to: "/admin/tomtom", label: "TomTom API", icon: Activity },
  { to: "/admin/contacts", label: "Anliegen", icon: MessageSquare },
  { to: "/admin/legal", label: "Rechtliches", icon: ScrollText },
  { to: "/admin/wartung", label: "Wartung", icon: Wrench },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex bg-neutral-50">
      <aside className="w-64 border-r border-brand-line bg-white flex-shrink-0 flex flex-col">
        <Link to="/admin" className="flex items-center gap-3 px-6 py-6 border-b border-brand-line" data-testid="admin-logo">
          <img src={DETMOLD_LOGO} alt="Detmold" className="h-9 w-auto" />
          <span className="text-xs leading-tight text-neutral-500 border-l border-brand-line pl-3">
            Admin<br />Quartier am Hornschen Tor
          </span>
        </Link>
        <nav className="flex-1 p-3 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                  isActive
                    ? "bg-[hsl(var(--brand-soft))] text-[hsl(var(--brand-green-dark))] font-medium"
                    : "text-neutral-700 hover:bg-neutral-100"
                }`
              }
            >
              <l.icon className="h-4 w-4" />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-brand-line p-4 text-xs text-neutral-500">
          <p className="mb-2 truncate" data-testid="admin-user-email">{user?.email}</p>
          <button
            onClick={async () => { await logout(); nav("/admin/login"); }}
            data-testid="admin-logout"
            className="flex items-center gap-2 text-neutral-600 hover:text-neutral-900"
          >
            <LogOut className="h-4 w-4" /> Abmelden
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-x-hidden">
        <div className="max-w-5xl mx-auto px-8 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
